export default {
  label: {
    titleEditProfile: 'Chỉnh sửa thông tin tài khoản',
    username: 'Tài khoản',
    action: 'action',
    conversionRate: 'Tỉ lệ chuyển đổi',
    userActive: 'Số nhân viên làm việc hôm nay',
    totalCall: 'Tổng số cuộc gọi',
    numberDataNoCall: 'Số data không gọi nhưng vẫn bấm phím chức năng',
    numberCallDone: 'Số lượng khách đồng ý',
    numberGuestNoAnswer: 'Số lượng khách không bắt máy',
    numberGuestRefuse: 'Số lượng khách từ chối',
    numberGuestNoConnect: 'Số lượng khách không liên lạc được',
    login: 'Đăng nhập',
    password: 'Mật khẩu',
    account: 'Tài khoản',
    titleLogin: 'Đăng nhập',
    id: 'ID',
    nameEmployee: 'Tên nhân viên',
    operatorLimit: 'Giới hạn nhà mạng',
    dataLimit: 'Giới hạn loại data',
    productLimit: 'Giới hạn sản phẩm',
    dataNocall: 'Data chưa gọi',
    status: 'Trạng thái',
    active: 'Hoạt động',
    edit: 'Chỉnh sửa',
    noActive: 'Không hoạt động',
    hardSalary: 'Lương cứng',
    salaryKPI: 'Lương KPI',
    salary: 'Lương',
    importKH: 'Import dữ liệu khách hàng',
    fileExcel: 'File excel',
    browse: 'Browse',
    fileTemplate: 'download file mẫu',
    titleEmployeeManager: 'Danh sách nhân viên',
    titleDataManager: 'Danh sách loại Data',
    filterBy: 'Lọc theo lương',
    addNewEmployee: 'Thêm nhân viên',
    addNewData: 'Thêm loại Data',
    rePassword: 'Nhập lại mật khẩu',
    name: 'Họ tên',
    save: 'Lưu',
    cancel: 'Huỷ bỏ',
    chooseOperator: '---Chọn giới hạn nhà mạng---',
    chooseStatus: '---Chọn trạng thái---',
    chooseUserType: '---Chọn loại lương---',
    userType: 'Loại lương',
    numberNoCall: 'Số lượng chưa gọi',
    numberAgree: 'Số lượng đồng ý',
    numberDeclined: 'Số lượng từ chối',
    numberDidNotPickUp: 'Số lượng không nhấc máy',
    dataName: 'Tên Loại Data',
    assignedUser: 'Gán cho nhân viên',
    updateLabelData: 'Chỉnh sửa loại DATA',
    label: "Cập nhật",
    insert: "Thêm",
    description: "Mô tả",
    editProfile: "Chỉnh sửa",
    descPassword: "Nhập mật khẩu mới vào.Bỏ trống nếu không thay đổi mật khẩu",
    titleInfoProfile: "Thông tin tài khoản",
    sale: {
      notBuy: 'Không đồng ý mua',
      notPickUp: 'Khách không nghe máy',
      notCatch: 'SĐT không liên lạc được'
    },
    noData: 'Không có dữ liệu',
    all: '---Tất cả---',
    optionEmpty: '---Chọn---',
    orderModalTitle: 'Xác nhận mua hàng',
    orderModalConfirmation: 'Bạn có chắc chắn khách hàng đồng ý mua?',
    close: 'Đóng',
    accept: 'Đồng ý',
    createOrderSuccess: 'Đã tạo đơn hàng thành công',
    info: 'Thông báo',
    CustomerList: 'Danh sách đơn hàng',
    product: 'Sản phẩm',
    employee: 'Nhân viên',
    exportExcel: 'Xuất excel?',
    publishOrder: 'Đăng đơn',
    deliveryStatus: 'Trạng thái giao hàng',
    orderId: 'Mã',
    phoneNumber: 'SĐT',
    address: 'Địa chỉ',
    dataType: 'Loại data',
    productName: 'Tên sản phẩm',
    price: 'Giá',
    calledSale: 'Nhân viên gọi',
    isExportedExcel: 'Xuất/Chưa xuất Excel',
    deliveryId: 'Mã vận đơn',
    orderStatusNotCall: 'Chưa gọi',
    orderStatusAccept: 'Đồng ý',
    orderStatusReject: 'Từ chối',
    orderStatusNotPickUp: 'Không nhấc máy',
    orderStatusNotCatch: 'Thuê bao',
    orderStatusOther: 'Khác',
    orderedProduct: 'Sản phẩm đặt mua',
    exportExcelStatus1: 'Chưa xuất',
    exportExcelStatus2: 'Xuất',
    exportExcelStatus3: '---Xuất/Chưa xuất---',
    deliveryStatusList: {
      status0: 'Hủy đơn hàng',
      status1: 'Chưa tiếp nhận',
      status2: 'Đã tiếp nhận',
      status3: 'Đã lấy hàng/Đã nhập kho',
      status4: 'Đã điều phối giao hàng/Đang giao hàng',
      status5: 'Đã giao hàng/Chưa đối soát',
      status6: 'Đã đối soát',
      status7: 'Không lấy được hàng',
      status8: 'Hoãn lấy hàng',
      status9: 'Không giao được hàng',
      status10: 'Delay giao hàng',
      status11: 'Đã đối soát công nợ trả hàng',
      status12: 'Đã điều phối lấy hàng/Đang lấy hàng',
      status13: 'Đơn hàng bồi hoàn',
      status14: 'Đang trả hàng (COD cầm hàng đi trả)',
      status15: 'Đã trả hàng (COD đã trả xong hàng)',
      status16: 'Shipper báo đã lấy hàng',
      status17: 'Shipper (nhân viên lấy/giao hàng) báo không lấy được hàng',
      status18: 'Shipper báo delay lấy hàng',
      status19: 'Shipper báo đã giao hàng',
      status20: 'Shipper báo không giao được giao hàng',
      status21: 'Shipper báo delay giao hàng',
      status123: 'Shipper báo đã lấy hàng',
      status127: 'Shipper (nhân viên lấy/giao hàng) báo không lấy được hàng',
      status128: 'Shipper báo delay lấy hàng',
      status45: 'Shipper báo đã giao hàng',
      status49: 'Shipper báo không giao được giao hàng',
      status410: 'Shipper báo delay giao hàng'
    },
    pagination: {
      display: 'Hiển thị'
    },
    titleEditOrderPage: 'Sửa đơn hàng',
    dateCalling: 'Ngày gọi',
    timeCalling: 'Giờ gọi',
    datetimeCalling: 'Ngày giờ gọi',
    assignedEmployee: 'Nhân viên phụ trách',
    shopName: 'Shop bán',
    cod: 'Tiền hàng',
    selectFile: 'Chọn file',
    error: 'Lỗi',
    row: 'Dòng',
    importGHTK: 'Import dữ liệu từ GHTK',
    importGHTKContent: 'Form này sử dụng để import trạng thái vận đơn từ GiaoHangTietKiem vào hệ thống để thống kê tỷ lệ hoàn hàng/giao hàng thành công của mỗi nhân viên.',
    customerName: 'Tên khách',
    note: 'Ghi chú',
    createdAt: 'Ngày tạo',
    titleEditOrderNote: 'Form nhập phản hồi khách hàng',
    dashboardConvertRatio: 'Tỷ lệ chuyển đổi',
    dashboardAcceptTask: 'Đồng ý',
    dashboardRejectTask: 'Từ chối',
    dashboardNoAnswerTask: 'Không bắt máy',
    dashboardNoCatchTask: 'Không liên lạc được',
    dashboardTotalTask: 'Tổng cuộc gọi',
    profile: 'Tài khoản',
    summary: 'Thống kê',
    callHistory: 'Lịch sử gọi',
    logOut: 'Đăng xuất',
    hello: 'Xin chào',
    email: 'Email',
    dob: 'Ngày sinh',
    back: 'Quay lại',
    notCallSummaryTitle: 'Thống kê dữ liệu chưa gọi',
    otherOperators: 'Chưa xác định nhà mạng',
    todayGeneralSummary: 'Tổng quan ngày hôm nay',
    todaySummary: 'Thống kê hôm nay',
    productSectionTitle: 'Danh sách loại sản phẩm',
    addNewProduct: 'Thêm mới sản phẩm',
    quantity: 'Số lượng',
    exportExcelLabel: 'Xuất Excel',
    exportExcelGhtkLabel: 'Xuất Excel GHTK',
    historyCalling: 'Lịch sử cuộc gọi',
    search: 'Tìm kiếm',
    customerProduct: 'Sản phẩm đã mua',
    reportTitle: 'Báo cáo',
    reportSaleTitle: 'Báo cáo tỷ lệ giao hàng thành công theo từng nhân viên',
    today: 'Hôm nay',
    thisWeek: 'Tuần này',
    thisMonth: 'Tháng này',
    thisYear: 'Năm nay',
    reportAll: 'Tất cả',
    reportDelivery: 'Giao thành công',
    reportNotDelivery: 'Khác',
    fromDate: 'Từ ngày',
    toDate: 'Tới ngày',
    saleReport30Days: 'Thống kê tỷ lệ giao hàng 30 ngày',
    returnDelivery: 'Hoàn sản phẩm',
    delete: 'Xóa',
    deleteProductTitle: 'Bạn có muốn xóa sản phẩm này?',
    deleteSaleTitle: 'Bạn có muốn xóa nhân viên này?',
    totalOrderNumber: 'Số ĐH',
    totalExportedOrderNumber: 'Số ĐH đã xuất',
    totalExportedOrderNotDeliveryNumber: 'Số ĐH đã xuất không tìm thấy trên GHTK',
    tableElements: 'kết quả',
    reOrderTask: 'Sắp xếp lại',
    convertToNotCall: 'Chuyển qua chưa gọi',
    confirmConvertToNotCall: 'Bạn chắc chắn muốn chuyển qua chưa gọi?'
  },
  menu: {
    dashboard: 'Dashboard',
    orderManagement: 'Quản lý khách hàng',
    employeeManager: 'Quản lý nhân viên',
    careOrder: 'Care đơn',
    report: 'Báo cáo',
    import: 'Import',
    manageDataTypes: 'Quản lý loại dữ liệu'
  },
  title: {
    home: "Trang chủ",
    login: "Đăng nhập",
    sales: "Nhân viên",
    admin: "Admin",
    employee: "Quản lý nhân viên",
    order: "Quản lý đơn hàng",
    importPage: "Import",
    dataManager: 'Quản lý dữ liệu',
    reportPage: 'Báo cáo',
    edit: 'Chỉnh sửa',
    sendZns: 'Gửi Zns',
    importHistory: 'Lịch sử Import',
    znsHistory: 'Lịch sử ZNS',
  }
}
